
import React from 'react';
import { Route } from 'react-router-dom';


const Factory = ( model, metadata ) => {
  return model.identity.map( ( item ) => {

    const Pages = require( '../../../pages/auth' ).default;

    const Page = Pages.Meta[ item.Page ];

    return <Route path={`/${item.slug}`} element={<Page />} />;
  } );
};

export default Factory;